import { useRecords } from "../api/useRecords";
import { canSeeDashboard, filterPageDashboards } from "./nativeDashboardsAccess";
import { NativeDashboardRecord } from "./types";

const NATIVE_DASHBOARDS_FIELDS = "id,key,name,sort,status,data_scope,viewer_rules,drill_roles.directus_roles_id";
// Fallback quando os campos novos ainda não são legíveis (permissões/field-level): mantém a listagem viva.
const NATIVE_DASHBOARDS_LEGACY_FIELDS = "id,key,name,sort,status";
const NATIVE_DASHBOARDS_STALE_TIME = 5 * 60 * 1000;

const NATIVE_DASHBOARDS_EXTRA_OPTIONS = {
    sort: "sort",
    filter: { status: { _eq: "published" } },
};

export const useNativeDashboards = (registryKeys: Array<string> = []) => {
    const richResult = useRecords("native_dashboards", NATIVE_DASHBOARDS_FIELDS, {
        extraOptions: NATIVE_DASHBOARDS_EXTRA_OPTIONS,
        staleTime: NATIVE_DASHBOARDS_STALE_TIME,
    });

    const shouldUseLegacyFallback = richResult.status === "error";
    const legacyResult = useRecords("native_dashboards", NATIVE_DASHBOARDS_LEGACY_FIELDS, {
        queryKeyExtraValue: "native-dashboards-legacy",
        extraOptions: NATIVE_DASHBOARDS_EXTRA_OPTIONS,
        staleTime: NATIVE_DASHBOARDS_STALE_TIME,
        enabled: shouldUseLegacyFallback,
    });

    const activeResult = shouldUseLegacyFallback ? legacyResult : richResult;
    const records: Array<NativeDashboardRecord> = activeResult.data?.items || [];
    const pageDashboards = filterPageDashboards(records, registryKeys);

    const checkCanSeeDashboard = (dashboardKey: string) => {
        const isAllowed = canSeeDashboard(records, dashboardKey);
        return isAllowed;
    };

    return { records, pageDashboards, status: activeResult.status, canSeeDashboard: checkCanSeeDashboard };
};
